<ng-container *transloco="let t">
  <h2 mat-dialog-title>
    {{
      data.marker.type === 'Manual'
        ? t('features.session.playback.deleteMarkerDialog.manualTitle')
        : t('features.session.playback.deleteMarkerDialog.importTitle')
    }}
  </h2>

  <form #formDirective="ngForm" [formGroup]="form" (submit)="save()">
    <mat-dialog-content>
      @if (data.marker.type === 'Import') {
        <p>{{ t('features.session.playback.deleteMarkerDialog.importText') }}</p>
      }

      <mat-form-field>
        <mat-label>{{ t('features.session.playback.participants') }}</mat-label>
        <mat-select multiple [formControl]="participantControl">
          @for (participant of data.participantOptions; track participant.mindDeviceId) {
            <mat-option [value]="participant.mindDeviceId">{{ participant.participantName }}</mat-option>
          }
        </mat-select>
        <mat-error data-testid="participant-error">
          {{ participantControl.errors | validatorError }}
        </mat-error>
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="center">
      <button
        class="button-destructive"
        data-testid="submit-button"
        matButton="filled"
        type="submit"
        [disabled]="formDirective.invalid && formDirective.submitted"
      >
        {{
          data.marker.type === 'Manual'
            ? t('features.session.playback.deleteMarkerDialog.deleteManualMarkerButtonText')
            : t('features.session.playback.deleteMarkerDialog.deleteImportMarkerButtonText')
        }}
      </button>

      <button class="button-destructive" data-testid="cancel-button" matButton type="button" (click)="cancel()">
        {{ t('common.cancel') }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-container>
